export const loadKindly = () => {
  return new Promise((resolve, reject) => {
    const language =
      document.cookie.match(/digipost\.language=((nb|nn|en)+)/)?.[1] === "en"
        ? "en"
        : "no";

    const script = document.createElement("script");

    window.kindlyOptions = {
      customFont: '"Posten Sans", arial, sans-serif',
    };

    script.onload = resolve;
    script.onerror = reject;
    script.defer = true;
    script.id = "kindly-chat";
    script.setAttribute("data-bot-key", "08de193c-5262-4190-8083-cb2f32c77c0d");
    script.setAttribute("data-language", language ?? "no");
    script.src = "https://chat.kindlycdn.com/kindly-chat.js";

    document.head.append(script);
  });
};

export const openKindlyChat = () => {
  const chatButton = document.querySelector<HTMLButtonElement>(
    "#ChatButtonContainer button",
  );

  if (chatButton) {
    chatButton.click();
  } else if (!document.getElementById("kindly-chat")) {
    loadKindly().then(() => {
      document.addEventListener("kindly:load", () => {
        window.kindlyChat?.openChat();
      });
    });
  }
};
